import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { defineMessages, injectIntl, intlShape } from 'react-intl';

import GreenFlag from '../green-flag/green-flag.jsx';
import StopAll from '../stop-all/stop-all.jsx';
import TurboMode from '../turbo-mode/turbo-mode.jsx';

import styles from './controls.css';

import HideIcon from './hide.svg';

const messages = defineMessages({
    goTitle: {
        id: 'gui.controls.go',
        defaultMessage: 'Go',
        description: 'Green flag button title'
    },
    stopTitle: {
        id: 'gui.controls.stop',
        defaultMessage: 'Stop',
        description: 'Stop button title'
    }
});

const Controls = function (props) {
    const {
        active,
        className,
        intl,
        onGreenFlagClick,
        onStopAllClick,
        screenSize,
        isStageVisible,
        turbo,
        ...componentProps
    } = props;
    return (
        <div
            className={classNames(styles.controlsContainer, className)}
            {...componentProps}
        >
            <GreenFlag
                active={active}
                title={intl.formatMessage(messages.goTitle)}
                onClick={onGreenFlagClick}
            />
            <StopAll
                active={active}
                title={intl.formatMessage(messages.stopTitle)}
                onClick={onStopAllClick}
            />
            {turbo ? (
                <TurboMode />
            ) : null}

            {screenSize === 'mobile' ? (
                <button
                    className={styles.toggleStageButton}
                    onClick={props.toggleStageVisibility}
                >
                  <img
                        src={HideIcon}
                        alt="Collapse"
                        className={styles.collapseArrowIcon}
                    />
                </button>
            ) : null}
        </div>
    );
};

Controls.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    intl: intlShape.isRequired,
    onGreenFlagClick: PropTypes.func.isRequired,
    onStopAllClick: PropTypes.func.isRequired,
    turbo: PropTypes.bool,
    screenSize: PropTypes.string.isRequired,
    isStageVisible: PropTypes.bool.isRequired,
    toggleStageVisibility: PropTypes.func.isRequired
};

Controls.defaultProps = {
    active: false,
    turbo: false
};

const mapStateToProps = state => ({
    screenSize: state.scratchGui.screenSize.screenSize,
    isStageVisible: state.scratchGui.stageVisibility.isStageVisible
});

const mapDispatchToProps = dispatch => ({
    toggleStageVisibility: () => dispatch({ type: 'TOGGLE_STAGE_VISIBILITY' })
});


export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(Controls));